

















































import {Component, Mixins} from 'vue-mixin-decorator';
import {Prop} from 'vue-property-decorator';
import {Inject} from 'inversify-props';

import {Connection} from '@/model/network/connection/Connection';
import {ConnectionType, ConnectionTypeMetadata} from '@/model/network/connection/ConnectionType';
import {ConnectionState} from '@/model/network/connection/ConnectionState';

import {INetworkConnectionService} from '@/services/network/INetworkConnectionService';

import NetworkIpStatusDisplay from '@/components/Networking/Connection/NetworkIpStatusDisplay.vue';

import {BaseComponent} from '@/mixins/BaseComponent';

@Component({
  components: {NetworkIpStatusDisplay},
})
export default class NetworkConnectionsList extends Mixins<BaseComponent>(BaseComponent) {
  @Prop()
  public connections!: Connection[];

  @Inject(Symbol.for('INetworkConnectionService'))
  private connectionService!: INetworkConnectionService;

  private ConnectionTypeMetadata = ConnectionTypeMetadata;
}
